let supportPromise: Promise<boolean> | null = null;

export const checkOPFSWriteSupport = (): Promise<boolean> => {
    if (supportPromise) return supportPromise;

    if (typeof navigator?.storage?.getDirectory !== "function") {
        supportPromise = Promise.resolve(false);
        return supportPromise;
    }

    supportPromise = (async () => {
        try {
            const root = await navigator.storage.getDirectory();
            const dir = await root.getDirectoryHandle("__opfs_test__", {
                create: true,
            });
            const testFile = await dir.getFileHandle("test.json", {
                create: true,
            });
            await (await testFile.createWritable()).close();
            await dir.removeEntry("test.json");
            await root.removeEntry("__opfs_test__");
            return true;
        } catch {
            return false;
        }
    })();

    return supportPromise;
};
